var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHardDrives(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 13.5H4.5C4.08579 13.5 3.75 13.8358 3.75 14.25V18.75C3.75 19.1642 4.08579 19.5 4.5 19.5H19.5C19.9142 19.5 20.25 19.1642 20.25 18.75V14.25C20.25 13.8358 19.9142 13.5 19.5 13.5Z",
    stroke: "#677791",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 4.5H4.5C4.08579 4.5 3.75 4.83579 3.75 5.25V9.75C3.75 10.1642 4.08579 10.5 4.5 10.5H19.5C19.9142 10.5 20.25 10.1642 20.25 9.75V5.25C20.25 4.83579 19.9142 4.5 19.5 4.5Z",
    stroke: "#677791",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 8.625C17.4963 8.625 18 8.12132 18 7.5C18 6.87868 17.4963 6.375 16.875 6.375C16.2537 6.375 15.75 6.87868 15.75 7.5C15.75 8.12132 16.2537 8.625 16.875 8.625Z",
    fill: "#677791"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 17.625C17.4963 17.625 18 17.1213 18 16.5C18 15.8787 17.4963 15.375 16.875 15.375C16.2537 15.375 15.75 15.8787 15.75 16.5C15.75 17.1213 16.2537 17.625 16.875 17.625Z",
    fill: "#677791"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHardDrives);
export default __webpack_public_path__ + "static/media/HardDrives.9e4a2b3579854855ebf5eb8960c87a48.svg";
export { ForwardRef as ReactComponent };